<template lang="pug">
v-dialog(v-model='shown', persistent)
  v-card.number-input-modal
    .head-area
    .value-area
      .value {{ formattedValue }}
    .input-area
      .numbers-area
        .btn-wrap(v-for='n in numbers', :value='n+1')
          v-btn.number(fab, @click='onClickNumber(n+1)') {{ n+1 }}
        .btn-wrap
        .btn-wrap(value=0)
          v-btn.number(fab, @click='onClickNumber(0)') 0
        .btn-wrap
      .functions-area
        v-btn.clear(@click='onClickAc') AC
        v-btn.del(@click='onClickDel') Del
        v-btn.cancel(@click='onClickCancel') Cancel
        v-btn.ok(@click='onClickOK') OK
</template>

<style lang='less'>
@import '~@/assets/common.less';
.number-input-modal:extend(.relative) {
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  > *:extend(.relative, .full-width) { box-sizing: border-box; }
  .head-area:extend(.absolute) {
    height: 40px;
    top: 0px;
    left: 0px;
    background-color: #0a1e5b;
  }
  .value-area {
    margin-top: 30px;
    margin-bottom: 20px;
    height: 50px;
    padding: 5px;
    .value:extend(.relative, .full-widthheight, .center-mid) {
      box-sizing: border-box;
      border-bottom: solid 1px black;
      color: black;
      font-size: 30px;
      font-weight: 900;
      padding: 0px 10px 0px 10px;
      -webkit-box-pack: end;
    }
  }
  .input-area {
    width: 100%;
    > *:extend(.absolute) {
      top: 0px;
    }
    .numbers-area {
      width: 75%;
      .btn-wrap:extend(.relative, .center-mid) {
        width: 30%;
        float: left;
        .v-btn:extend(.relative) {
        }
      }
      .btn-wrap:before:extend(.rated-box-1x1) {}
    }
    .functions-area {
      height: 100%;
      width: 25%;
      right: 0px;
      padding-top: 10px;
      display: flex;
      flex-direction: column;
      button {
        margin-bottom: 10px;
        height: 15%;
      }
      .cancel {
        background-color: orange;
        color: white;
      }
      .ok {
        height: 40%;
      }
    }
  }
  .input-area:before:extend(.rated-box-1x1) {}

  .v-btn.ok {
    background-color: #0a1e5b;
    color: white;
  }
}
</style>

<script>
export default {
  computed: {
    formattedValue () {
      return this.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  data () {
    return {
      shown: false,
      status: null,
      numbers: [...Array(9).keys()],
      value: 0
    }
  },
  methods: {
    onClickAc () {
      this.value = 0
    },
    onClickDel () {
      this.value = parseInt(this.value / 10)
    },
    onClickCancel () {
      this.status = 'canceled'
    },
    onClickOK () {
      this.status = 'done'
    },
    onClickNumber (n) {
      if (this.value > 999999) { return }
      this.value = this.value * 10 + parseInt(n)
    },
    show () {
      this.value = 0
      this.status = 'waiting'
      this.shown = true
      const that = this
      const delay = (t) => { return new Promise(resolve => setTimeout(resolve, t)) }
      return new Promise(async function (resolve, reject) {
        while (that.status === 'waiting') {
          await delay(200)
        }
        that.shown = false
        return resolve({value: that.value, status: that.status})
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/productionStatus/numberInputModal.vue